import { IUserSettingsTab } from "../../models";
import { UserService } from "../../services";
import { GeneralSettingsComponent } from "../general-settings/general-settings.component";

const items: IUserSettingsTab[] = [
  {
    title: "General", selected: true, component: GeneralSettingsComponent
  },
  {
    title: "Dummy For Test", selected: false, component: GeneralSettingsComponent
  },
];

export function initSettingsTabs(userService: UserService) {
  const items: IUserSettingsTab[] = [
    {
      title: "General", selected: true, component: GeneralSettingsComponent
    },
    {
      title: "Dummy For Test", selected: false, component: GeneralSettingsComponent
    },
  ];

  return () => userService.registerSettingsTabs(items);
}
